import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { User } from "src/app/models/user";
import { UserDataManager } from "../../user/UserDataManager";
import { ProgressBarService } from "src/app/services/progress-bar.service";
import { MessageHandlerService } from "src/app/services/message-handler.service";
import { NotificationService } from "src/app/services/notification.service";
import { PatientService } from "src/app/services/patient/patient.service";
import { notificationMessage, Notifications } from "src/app/models/notification";
import { defaultSelectedPatientVisitRows, PatientVisitRows, submissionStatus, visitDetailColors, REVIEWED_STATUS, NOT_ADDRESSED_STATUS, NEEDS_CORRECTION_STATUS, PRE_QA_STATUS } from "src/app/models/patient";
import { Subscription } from "rxjs";
import { allowToUpdateVisitsRoles, dateAndTimeFormat, dateFormat, RoleID, REPROCESS_SUCCESS_MESSAGE, REPROCESS_ERROR_MESSAGE, TOAST_SUCCESS, TOAST_ERROR, TOAST_ERROR_TITLE, QA_NOTE_SAVED_SUCCESS, QA_NOTE_SAVE_ERROR, CSV_MIME_TYPE, CSV_EXPORT_NO_ROWS_SELECTED_MESSAGE } from "../../common/Constants";
import { VisitDetailsService } from "src/app/services/visit-details.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { questionDescription } from "../../helper/question.description";
import { reformatNormalizedElementAnswersData, reformatVisitsAnswersData, reformatWithSpecialCharacters } from "../../helper/functions";
import {replaceObjectKeyWithRegluarExperssion} from "../../services/util/helper.function";

@Component({
  selector: "app-visit-details",
  templateUrl: "./visit-details.component.html",
  styleUrls: ["./visit-details.component.scss"],
})
export class VisitDetailsComponent implements OnInit, OnDestroy {
  @Input() patientSubmission: any;
  currentUser: User;
  isMasterCheckboxChecked: boolean = false;
  activeAgencyRole;
  rolesEnum = RoleID;
  selectedRows: any[] = [];
  selectedRowsForVisit: any[] = defaultSelectedPatientVisitRows;
  reProcessLoading = false;
  @Output() reloadPatientSubmission = new EventEmitter();
  @Output() closeSideBar = new EventEmitter();
  @Output() reprocessedObject = new EventEmitter();
  @Output() eSOCUploadDisplay = new EventEmitter();
  display;
  subscriptions: Subscription[] = [];
  IOHAgencyAdminAdministrator = RoleID.IOHAgencyAdmin;
  iohAdmin = RoleID.iohAdmin;
  dateFormat = dateFormat;
  dateAndTimeFormat = dateAndTimeFormat;
  questions: any;
  suggestions: any;
  showDollarSign: boolean = false;
  showESOCUpload: boolean = false;
  visibleRows: any[] = PatientVisitRows;
  companyAdmin = RoleID.companyAdmin;
  visitDetailColors = visitDetailColors;
  REVIEWED_STATUS = REVIEWED_STATUS;
  NOT_ADDRESSED_STATUS = NOT_ADDRESSED_STATUS;
  NEEDS_CORRECTION_STATUS = NEEDS_CORRECTION_STATUS;
  PRE_QA_STATUS = PRE_QA_STATUS;
  crossRulesIssues = [];
  normalIssues = [];
  preQAIssuesExist: boolean = false;
  crossRulesIssuesCount = 0;
  allowToUpdateVisit: boolean = false;
  collapsedSections: { [key: string]: boolean } = {
    preQaCheck: false,
    postQaCheck: false,
    chartingDetails: false,
    additionalQuestions: false,
    nonOasisQuestionnaire: false,
    errorsAndWarnings: false
  };
  editingQaNotesIndex: number = null;
  editingQaNotesValue: string = '';
  savingQaNotes: boolean = false;
  updatingQaStatus: boolean = false;

  constructor(
    private readonly progressBarService: ProgressBarService,
    private patientService: PatientService,
    private messageHandlerService: MessageHandlerService,
    private userDataManager: UserDataManager,
    private notificationService: NotificationService,
    private visitDetailsService: VisitDetailsService,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit(): void {
    this.replaceVisitType();
    this.getUserProfile();
    this.getActiveAgencyRole();
    this.getQuestionsObject();
    this.getSuggestionsFromFinApi();
    this.getSelectedRows();
    this.getCrossRulesIssues();
    this.nonProdRoles();
    this.replaceCorrectionDetails();
  }

  getCrossRulesIssues() {
    this.crossRulesIssues = [];
    this.normalIssues = [];
    this.crossRulesIssuesCount = 0;
    const issues = this.patientSubmission?.issues || [];

    issues.forEach((issue) => {
      if (issue?.crossRule && issue?.crossRuleType === "impact") {
        this.crossRulesIssues.push(issue);
      } else {
        if(!this.patientSubmission?.preQaCheckQuestions?.questions){
          this.normalIssues.push(issue);
        }
      }
    });
    if(this.patientSubmission.preQaCheckQuestions?.questions.length > 0){
      this.normalIssues.push(...(this.patientSubmission.preQaCheckQuestions.questions || []));
      this.preQAIssuesExist = true;
    }
    //this.normalIssues = [...(this.patientSubmission?.preQaCheckQuestions?.questions || [])];

    let handledIssues = [];

    for (let i = 0; i < this.crossRulesIssues?.length; i++) {
      let normalizeList = [];
      let k = 0;
      for (let j = 0; j < this.crossRulesIssues[i].otherValues.length; j++) {
        let id1 = this.crossRulesIssues[i].question + this.crossRulesIssues[i].otherValues[j].title;
        let id2 = this.crossRulesIssues[i].otherValues[j].title + this.crossRulesIssues[i].question;
        if (handledIssues.includes(id1) || handledIssues.includes(id2)) {
          continue;
        } else {
          handledIssues.push(id1);
          handledIssues.push(id2);
          this.crossRulesIssuesCount++;

          let newEntry = {
            question: this.crossRulesIssues[i].question,
            questionDescription: this.crossRulesIssues[i]?.questionDescription,
            answers: this.crossRulesIssues[i].answers,
            status: k == 0 ? this.crossRulesIssues[i].status : undefined,
            answerDescription: this.crossRulesIssues[i]?.answerDescription,
            normalizedElement: {
              question: this.crossRulesIssues[i].otherValues[j].title,
              questionDescription: questionDescription[this.crossRulesIssues[i].otherValues[j].title],
              answers: this.crossRulesIssues[i].otherValues[j].answers,
              answerDescription: this.crossRulesIssues[i].otherValues[j].answerDescription,
            },
          };
          k++;
          reformatNormalizedElementAnswersData(newEntry?.normalizedElement);
          normalizeList.push(newEntry);
        }
      }
      this.crossRulesIssues[i].normalizedList = normalizeList;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  getUserProfile() {
    this.subscriptions.push(
      this.userDataManager.user$.subscribe((res) => {
        if (res) {
          if (res.currentUserRole == RoleID.Clinician) {
            this.showESOCUpload = true;
          }
          this.currentUser = res;
        }
      }),
    );
  }

  getActiveAgencyRole() {
    this.subscriptions.push(
      this.userDataManager.activeAgencyRole$.subscribe((res) => {
        if (res) {
          this.activeAgencyRole = res;
        }
      }),
    );
  }

  reProcess() {
    this.reProcessLoading = true;
    this.patientService.reProcessSubmission(this.patientSubmission?._id).subscribe({
      next: (res) => {
        if (res?.success && res?.content) {
          this.patientSubmission.issues = res?.content?.submission?.issues;
          this.patientSubmission.totalErrorAndWarnings = res?.content?.errorCount + res?.content?.warningCount;
          this.reprocessedObject.emit(res?.content);
          this.patientSubmission.issues.forEach((issue) => {
            return (issue["message"] = reformatWithSpecialCharacters(issue?.message));
          });

          this.patientSubmission["issues"].forEach((issue) => {
            return (issue["questionDescription"] = questionDescription[issue?.question]);
          });
          reformatVisitsAnswersData(this.patientSubmission["issues"]);
          this.getCrossRulesIssues();
          this.messageHandlerService.generateToastMessage("success", "", REPROCESS_SUCCESS_MESSAGE);
        } else {
          this.messageHandlerService.generateToastMessage("error", "Error", REPROCESS_ERROR_MESSAGE);
        }
        this.reProcessLoading = false;
      },
      error: (error) => {
        this.reProcessLoading = false;
        this.messageHandlerService.generateToastMessage("error", "Error", error?.errorMessage || REPROCESS_ERROR_MESSAGE);
      }
    });
  }

  updateStatus(action, issueIndex) {
    if (
      issueIndex == -1 ||
      (this.patientSubmission?.issues && this.patientSubmission?.issues.length && this.patientSubmission?.issues[issueIndex]?.status) ||
      (this.patientSubmission?.submissionData?.issues[issueIndex]?.status &&
        this.patientSubmission?.submissionData?.issues &&
        this.patientSubmission?.submissionData?.issues.length)
    )
      try {
        this.progressBarService.setProgressBarVisibility(true);
        if (action === "ACCEPT") {
          this.patientSubmission.issues
            ? (this.patientSubmission.issues[issueIndex].status = "reviewed")
            : (this.patientSubmission.submissionData.issues[issueIndex].status = "reviewed");
        } else if (action === "RECHECK") {
          this.patientSubmission.issues
            ? (this.patientSubmission.issues[issueIndex].status = "recheck")
            : (this.patientSubmission.submissionData.issues[issueIndex].status = "recheck");
        }else if (action === "Reviewed") {
          this.patientSubmission.issues
            ? (this.patientSubmission.issues[issueIndex].status = REVIEWED_STATUS)
            : (this.patientSubmission.submissionData.issues[issueIndex].status = REVIEWED_STATUS);
        } else if (action === "Needs Correction") {
          this.patientSubmission.issues
            ? (this.patientSubmission.issues[issueIndex].status = NEEDS_CORRECTION_STATUS)
            : (this.patientSubmission.submissionData.issues[issueIndex].status = NEEDS_CORRECTION_STATUS);
        } else if (action === "ACCEPT ALL") {
          this.selectedRows.forEach((selectedRow) => {
            const selectedIndex = this.patientSubmission.issues.indexOf(selectedRow);
            if (selectedIndex != -1) {
              this.patientSubmission.issues
                ? (this.patientSubmission.issues[selectedIndex].status = "reviewed")
                : (this.patientSubmission.submissionData.issues.status = "reviewed");
            }
          });
        } else if (action === "RECHECK ALL") {
          this.selectedRows.forEach((selectedRow) => {
            const selectedIndex = this.patientSubmission.issues.indexOf(selectedRow);
            if (selectedIndex != -1) {
              this.patientSubmission.issues
                ? (this.patientSubmission.issues[selectedIndex].status = "recheck")
                : (this.patientSubmission.submissionData.issues.status = "recheck");
            }
          });
        }

        // else if (action === "ACCEPT ALL") {
        //   this.selectedRows.forEach((selectedRow) => {
        //     const selectedIndex = this.patientSubmission.issues.indexOf(selectedRow);
        //     if (selectedIndex != -1) {
        //       this.patientSubmission.issues
        //         ? (this.patientSubmission.issues[selectedIndex].status = "reviewed")
        //         : (this.patientSubmission.submissionData.issues.status = "reviewed");
        //     }
        //   });
        // } else if (action === "RECHECK ALL") {
        //   this.selectedRows.forEach((selectedRow) => {
        //     const selectedIndex = this.patientSubmission.issues.indexOf(selectedRow);
        //     if (selectedIndex != -1) {
        //       this.patientSubmission.issues
        //         ? (this.patientSubmission.issues[selectedIndex].status = "needs_correction")
        //         : (this.patientSubmission.submissionData.issues.status = "needs_correction");
        //     }
        //   });
        // }

        this.patientSubmission?.issues.forEach((issue) => {
          if (issue?.normalizedList) delete issue?.normalizedList;
        });

        this.patientService.updateStatus(this.patientSubmission).subscribe((res) => {
          if (res?.success) {
            this.messageHandlerService.generateToastMessage("success", "", res.message);
            this.reloadPatientSubmission.emit();
            if (issueIndex == -1 || this.patientSubmission.issues[issueIndex]?.status === NEEDS_CORRECTION_STATUS) this.createNotification(issueIndex);

            this.getCrossRulesIssues();
          } else if (res) {
            this.messageHandlerService.generateToastMessage("error", "Communication error:  ", res?.errorMessage);
          }
          this.progressBarService.setProgressBarVisibility(false);
        });
      } catch (error) {
        this.progressBarService.setProgressBarVisibility(false);
        this.messageHandlerService.generateToastMessage("error", "Communication error:  ", error);
      }
  }
  createNotification(issueIndex: number) {
    let question = "";
    let type = "";

    if (issueIndex == -1) {
      this.selectedRows.forEach((selectedRow, index) => {
        if (this.selectedRows.length - 1 !== index && index < 2) question = question + selectedRow?.question + ", ";
        else if (index == 2) {
          question = question + selectedRow?.question;
        } else if (this.selectedRows.length - 1 == index && index <= 2) question = question + selectedRow?.question;
        else if (index == 3) question = question + "...";
      });

      if (this.selectedRows.length == 1) {
        type = ` (type: ${this.selectedRows[0]?.type})`;
      }
    } else {
      question = this.patientSubmission?.issues[issueIndex]?.questionNo
        ? this.patientSubmission?.issues[issueIndex]?.questionNo
        : this.patientSubmission?.issues[issueIndex]?.question;
      type = ` (type: ${this.patientSubmission?.issues[issueIndex]?.type})`;
    }
    const visitType = this.patientSubmission?.visitType ? this.patientSubmission?.visitType : this.patientSubmission?.submissionData?.visitType;
    let message = notificationMessage.PLEASE_RECHECK_VISIT + visitType + notificationMessage.FOR + question + type;

    const notification: Notifications = {
      creator: this.currentUser?._id,
      receiver: this.patientSubmission.userId,
      message: message,
      createdAt: new Date(),
      read: false,
    };
    this.notificationService.createNotification(notification).subscribe((res) => {
      if (!res?.success) {
        this.messageHandlerService.generateToastMessage("error", "Communication error:  ", res?.errorMessage);
      }
    });
  }
  masterChangeCheckbox(event) {
    this.isMasterCheckboxChecked = event.checked;
  }
  getAlertType(input) {
    input = input.toLowerCase();
    if (["warning", "warn", "error"].includes(input) == true) {
      if (input == "error") {
        return "Error";
      }
      return "Warning";
    }
    return "Ok";
  }
  getLabelByValue(value: string): string {
    if (!value || value === '') {
      return 'Not Addressed';
    }
    const status = submissionStatus?.find((status) => status?.value === value);
    return status ? status.label : "Not Addressed";
  }

  getQuestionsObject() {
    if (!this.patientSubmission?.submissionData?.questionnaire) {
      this.questions = this.formatQuestions();
    } else {
      this.questions = this.patientSubmission?.submissionData?.questionnaire;
    }
  }

  formatQuestions() {
    const outputObject = {};
    if (Array.isArray(this.patientSubmission.questionnaire)) {
      for (const item of this.patientSubmission.questionnaire) {
        const question = item.question;
        const answerString = item.answer.toString();
        const answerArray = answerString.split(",");

        outputObject[question] = answerArray.length === 1 ? [parseInt(answerArray[0])] : answerArray.map((val) => parseInt(val));
      }

      return outputObject;
    } else {
      return this.patientSubmission.queqstionnaire;
    }
  }

  getSuggestionsFromFinApi() {
    let requestPayload = {
      icd10Codes: this.patientSubmission?.icdCodes ? this.patientSubmission?.icdCodes : this.patientSubmission?.patient?.icdCodes,
      questionnaire: this.questions,
    };

    this.visitDetailsService.getSuggestionsFromFinApi(requestPayload).subscribe((res: any) => {
      this.suggestions = res?.suggestions;
      this.showDollarSign = true;
    });
  }

  isRowVisible(rowName: string) {
    if (this.selectedRowsForVisit && this.selectedRowsForVisit.length)
      return this.selectedRowsForVisit.find((selectedRow) => selectedRow === rowName);
  }

  getSelectedRows() {
    if (!this.localStorageService.get("visitSettings" + this.currentUser?.aws_cognito_id)) {
      this.selectedRowsForVisit = defaultSelectedPatientVisitRows;
      this.localStorageService.set(
        "visitSettings" + this.currentUser?.aws_cognito_id,
        JSON.stringify({ selectedPatientVisitRows: this.selectedRowsForVisit }),
      );
    } else {
      this.selectedRowsForVisit = JSON.parse(this.localStorageService.get("visitSettings" + this.currentUser?.aws_cognito_id))
        ?.selectedPatientVisitRows
        ? JSON.parse(this.localStorageService.get("visitSettings" + this.currentUser?.aws_cognito_id))?.selectedPatientVisitRows
        : defaultSelectedPatientVisitRows;
    }
  }

  onSelectedRowsChange() {
    let selectedVisits = { selectedPatientVisitRows: [] };

    if (this.localStorageService.get("visitSettings" + this.currentUser?.aws_cognito_id))
      selectedVisits = JSON.parse(this.localStorageService.get("visitSettings" + this.currentUser?.aws_cognito_id));

    selectedVisits.selectedPatientVisitRows = this.selectedRowsForVisit;
    this.localStorageService.set("visitSettings" + this.currentUser?.aws_cognito_id, JSON.stringify(selectedVisits));
  }

  nonProdRoles() {
    this.allowToUpdateVisit = allowToUpdateVisitsRoles.includes(this.currentUser?.currentUserRole);
  }

  /**
   * This function is used to replace the correction details with the correct object key
   */
  replaceCorrectionDetails(){
    if (this.patientSubmission?.submissionData && this.patientSubmission?.submissionData?.correctionDetails) {
      this.patientSubmission.submissionData.correctionDetails = replaceObjectKeyWithRegluarExperssion(this.patientSubmission?.submissionData?.correctionDetails);
    }
  }

  replaceVisitType(){
    if (this.patientSubmission) {
      this.patientSubmission.visitType = this.patientSubmission?.visitType ? this.patientSubmission?.visitType : this.patientSubmission?.submissionData?.visitType;
    }
  }

  toggleSection(section: string) {
    this.collapsedSections[section] = !this.collapsedSections[section];
  }

  startEditingQaNotes(rowIndex: number, patientSubmissionIssue: any) {
    if (!this.allowToUpdateVisit) return;
    this.editingQaNotesIndex = rowIndex;
    this.editingQaNotesValue = patientSubmissionIssue?.qaNotes || '';
  }

  cancelEditingQaNotes() {
    this.editingQaNotesIndex = null;
    this.editingQaNotesValue = '';
  }

  saveQaNotes(rowIndex: number, patientSubmissionIssue: any) {
    if (this.savingQaNotes) return;

    this.savingQaNotes = true;
    const qaNoteValue = this.editingQaNotesValue?.trim() || '';
    const originalValue = patientSubmissionIssue?.qaNotes || '';

    patientSubmissionIssue.qaNotes = qaNoteValue;

    const payload = {
      ...this.patientSubmission.preQaCheckQuestions,
      questions: this.patientSubmission.preQaCheckQuestions.questions.map((question) => {
        if (question.question === patientSubmissionIssue.question) {
          return {
            ...question,
            qaNotes: qaNoteValue,
          };
        }
        return question;
      }),
    };

    this.visitDetailsService.updateQaNotes(payload).subscribe({
      next: (res: any) => {
        this.savingQaNotes = false;
        if (res?.success !== false) {
          this.messageHandlerService.generateToastMessage(TOAST_SUCCESS, "", QA_NOTE_SAVED_SUCCESS);
          this.cancelEditingQaNotes();
        } else {
          // Revert on error
          patientSubmissionIssue.qaNotes = originalValue;
          this.messageHandlerService.generateToastMessage(TOAST_ERROR, TOAST_ERROR_TITLE, res?.errorMessage || QA_NOTE_SAVE_ERROR);
        }
      },
      error: (error: any) => {
        this.savingQaNotes = false;
        // Revert on error
        patientSubmissionIssue.qaNotes = originalValue;
        this.messageHandlerService.generateToastMessage(TOAST_ERROR, TOAST_ERROR_TITLE, error?.errorMessage || QA_NOTE_SAVE_ERROR);
      }
    });
  }


  updateQaStatus(rowIndex: number, status: string) {
    if (this.updatingQaStatus) return;

    this.updatingQaStatus = true;


    const payload = {
      ...this.patientSubmission.preQaCheckQuestions,
      questions: this.patientSubmission.preQaCheckQuestions.questions.map((question) => {
        if (question.question === this.patientSubmission.preQaCheckQuestions.questions[rowIndex].question) {
          return { ...question, status: status };
        }
        return question;
      }),
    };

    this.visitDetailsService.updateQaNotes(payload).subscribe({
      next: (res: any) => {
        this.updatingQaStatus = false;
        if (res?.success !== false) {
          this.patientSubmission.preQaCheckQuestions.questions[rowIndex].status = status;
          this.messageHandlerService.generateToastMessage("success", "", "QA status updated successfully");
        } else {
          this.messageHandlerService.generateToastMessage("error", "Error", res?.errorMessage || "Failed to update QA status");
        }
      },
      error: (error: any) => {
        this.updatingQaStatus = false;
        this.messageHandlerService.generateToastMessage("error", "Error", error?.errorMessage || "Failed to update QA status");
      }
    });
  }

  selectAllPreQaRows() {
    if (this.normalIssues && this.normalIssues.length > 0) {
      this.selectedRows = [...this.normalIssues];
    }
  }

  buildCsvData(): string[] {
    // Helper function to strip HTML tags
    const stripHtml = (html: string): string => {
      if (!html) return '';
      const tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    };

    // Helper function to escape CSV values
    const escapeCsvValue = (value: any): string => {
      if (value === null || value === undefined) return '';
      let stringValue = String(value);
      // Remove "=" character from the beginning to prevent CSV injection
      if (stringValue.startsWith('=')) {
        stringValue = stringValue.substring(1);
      }
      // If value contains comma, newline, or quote, wrap in quotes and escape quotes
      if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    };

    // Build headers based on visible columns
    const headers: string[] = [];
    const columnKeys: string[] = [];

    if (this.isRowVisible('Q No')) {
      headers.push('Question');
      columnKeys.push('question');
    }
    if (this.isRowVisible('Description')) {
      headers.push('Description');
      columnKeys.push('description');
    }
    if (this.isRowVisible('Clinical Answer')) {
      headers.push('Clinical Answer');
      columnKeys.push('selectedAnswers');
    }
    if (this.isRowVisible('Suggested Answer')) {
      headers.push('Suggested Answer');
      columnKeys.push('suggestedAnswers');
    }
    if (this.isRowVisible('Clinical Decision')) {
      headers.push('Clinician Decision');
      columnKeys.push('requiredCorrection');
    }
    if (this.isRowVisible('Alert Type')) {
      headers.push('Alert Type');
      columnKeys.push('alertType');
    }
    if (this.isRowVisible('Rationale')) {
      headers.push('Rationale');
      columnKeys.push('rationale');
    }
    if (this.isRowVisible('QA Review Status')) {
      headers.push('QA Review Status');
      columnKeys.push('status');
    }
    if (this.isRowVisible('QA Notes')) {
      headers.push('QA Notes');
      columnKeys.push('qaNotes');
    }

    // Build CSV rows
    const csvRows: string[] = [];
    csvRows.push(headers.map(escapeCsvValue).join(','));

    this.selectedRows.forEach((row) => {
      const csvRow: string[] = [];

      columnKeys.forEach((key) => {
        let value = '';

        switch (key) {
          case 'question':
            value = row.question || '';
            break;
          case 'description':
            value = row.description ? row.description : '';
            break;
          case 'selectedAnswers':
            value = row.selectedAnswers || '';
            break;
          case 'suggestedAnswers':
            value = row.suggestedAnswers || '';
            break;
          case 'requiredCorrection':
            value = row.requiredCorrection ? 'Accepted' : 'Rejected';
            break;
          case 'alertType':
            value = this.getAlertType(row.alertType || '');
            break;
          case 'rationale':
            value = stripHtml(row.rationale || '');
            break;
          case 'status':
            value = this.getLabelByValue(row.status);
            break;
          case 'qaNotes':
            value = row.qaNotes || '';
            break;
        }

        csvRow.push(escapeCsvValue(value));
      });

      csvRows.push(csvRow.join(','));
    });

    return csvRows;
  }

  exportPreQaRowsToCsv() {
    if (!this.selectedRows || this.selectedRows.length === 0) {
      this.messageHandlerService.generateToastMessage("warn", "", CSV_EXPORT_NO_ROWS_SELECTED_MESSAGE);
      return;
    }

    const csvRows = this.buildCsvData();

    // Create CSV content
    const csvContent = csvRows.join('\r\n');

    // Create blob and open in new tab
    const blob = new Blob([csvContent], { type: CSV_MIME_TYPE });
    const url = URL.createObjectURL(blob);

    // Open CSV in new blank tab
    window.open(url, '_blank');

    // Clean up URL after a delay
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 1000);
  }
}
